import { H4, HStack, Typography } from "components/ui";
import React from "react";

const SearchResultHeading = ({ title, resultCount }: { title: string; resultCount: number }) => {
	return (
		<HStack paddingVertical={28} alignItems="center" justifyContent="space-between" paddingHorizontal={20}>
			<H4 weight="bold" sx={{ fontFamily: "Roboto_700Bold" }}>
				{title}
			</H4>
			<Typography.Paragraph>{resultCount} results</Typography.Paragraph>
		</HStack>
	);
};

export default SearchResultHeading;
